import { createSlice } from "@reduxjs/toolkit";
import { addDocument, fetchdocuments } from "./documents.action";

const initialState = {
  documentData: [],
  loading: false,
  headingData: {
    totalDocuments: 0,
    totalStaffVisibility: 0,
    totalEveryoneVisibility: 0,
    totalMeVisibility: 0,
  },
  error: null,
  page: 0,
  pages: 0,
  total: 0,
};

const documentSlice = createSlice({
  name: "documents",
  initialState,
  extraReducers: (builder) => {
    builder
      // ➤ Add Document
      .addCase(addDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addDocument.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || true;
      })

      // ➤ Fetch Documents
      .addCase(fetchdocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchdocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.documentData = action.payload?.data || [];
        state.page = action.payload?.page || 0;
        state.pages = action.payload?.pages || 0;
        state.total = action.payload?.total || 0;
        state.headingData = {
          totalDocuments: action.payload?.totalDocuments || 0,
          totalStaffVisibility:action.payload?.totalStaffVisibility || 0,
          totalEveryoneVisibility:action.payload?.totalEveryoneVisibility || 0,
          totalMeVisibility:action.payload?.totalMeVisibility || 0,
        };
      })
      .addCase(fetchdocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || true;
      });
    // .addCase(updateSignature.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    // })
    // .addCase(updateSignature.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.error = null;
    // })
    // .addCase(updateSignature.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload || true;
    // })

    // .addCase(deleteSignature.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    // })
    // .addCase(deleteSignature.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.error = null;
    // })
    // .addCase(deleteSignature.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload || true;
    // })
  },
});

export default documentSlice.reducer;
